import React, { createContext, useEffect, useState } from 'react';

export const TitleContext = createContext();

const TitleContextProvider = ({ children }) => {
  const [title, setTitle] = useState('Enter To Win');

  useEffect(() => {
    const contentBox = document.getElementById('content-box');
    if (contentBox) {
      contentBox.scroll({
        top: 0,
        behavior: 'smooth',
      });
    }
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, [title]);

  return (
    <TitleContext.Provider value={{ title, setTitle }}>
      {children}
    </TitleContext.Provider>
  );
};

export default TitleContextProvider;
